/**
 * <CancelAlternativesPage> — étape 2/5 : l'option avant de partir (page)
 *
 * Une seule alternative, choisie par le view-model sur le motif de l'étape précédente, et le lien
 * qui décline. La page ne connaît aucun motif : elle rend ce qu'on lui donne.
 *
 * « Poursuivre la résiliation » est la **sortie** de l'étape — c'est la seule façon d'avancer
 * quand on ne veut pas de l'option ; les deux boutons de la carte restent les deux actions.
 */
import React from "react"

import { type UICancelAlternative } from "../../../ports/primary/ui/types"
import { TextButton } from "../../atoms/Buttons/TextButton"
import { Stack } from "../../atoms/containers/Stack"
import { CancelAlternativeCard } from "../../organisms/CancelAlternativeCard"
import { CancelFlowStep } from "../../templates/CancelFlowStep"

const STEP_TITLE = "Avant de partir, une option qui pourrait vous aider"
const CONTINUE_LABEL = "Poursuivre la résiliation"

export type CancelAlternativesPageProps = {
    /** L'option montrée à cette étape. */
    alternative: UICancelAlternative
    /** Remonte la clé de l'action pressée — RDV, demande au support, pause. */
    onAction: (key: string) => void
    /** Décliner l'option et passer aux frais. */
    onContinue: () => void
    onBack?: () => void
    onClose?: () => void
    testID?: string
}

export function CancelAlternativesPage(props: CancelAlternativesPageProps) {
    const { alternative, onAction, onContinue, onBack, onClose, testID } = props

    return (
        <CancelFlowStep testID={testID} stepTitle={STEP_TITLE} step={2} onBack={onBack} onClose={onClose}>
            <Stack gap="5">
                <CancelAlternativeCard alternative={alternative} onAction={onAction} />
                <TextButton label={CONTINUE_LABEL} color="text-muted" size="sm" fullWidth onPress={onContinue} />
            </Stack>
        </CancelFlowStep>
    )
}
